export interface ClipboardInput {
  readonly text?: string;
  readonly file?: File;
}

export function transferredInput(data: DataTransfer): ClipboardInput {
  const file =
    Array.from(data.files)[0] ??
    Array.from(data.items)
      .find((item) => item.kind === 'file')
      ?.getAsFile();
  if (file) return { file };
  return { text: data.getData('text/plain') };
}

export async function readClipboard(): Promise<ClipboardInput> {
  if (typeof navigator.clipboard?.read === 'function') {
    const items = await navigator.clipboard.read();
    for (const item of items) {
      const type = item.types.find((candidate) => candidate.startsWith('image/'));
      if (type) {
        const blob = await item.getType(type);
        return { file: new File([blob], `clipboard.${type.split('/')[1] ?? 'png'}`, { type }) };
      }
    }
    const text: string[] = [];
    for (const item of items) {
      if (item.types.includes('text/plain'))
        text.push(await (await item.getType('text/plain')).text());
    }
    if (text.join('\n').trim()) return { text: text.join('\n') };
  } else if (typeof navigator.clipboard?.readText === 'function') {
    const text = await navigator.clipboard.readText();
    if (text.trim()) return { text };
  }
  throw new Error('Clipboard has no supported content');
}
